import * as React from "react";
import Random from "another-random-package";

export default function PortfolioImageWrapper(props){
    let {sources,fallback,style, ...rest} = props;
    return (
        <picture className={`${props.category}`} loading={"lazy"}>
            {
                sources.map(({sizes,srcSet},j)=>(
                    <source
                        key={Random.randomStringAlphaNumeric(12)}
                        srcSet={srcSet}
                        sizes={sizes}
                    />
                ))
            }
            {
                <img
                    src={fallback.src}
                    className={`${props.className}`}
                    srcSet={fallback.srcSet}
                    sizes={fallback.sizes}
                    style={style}
                    alt={""}
                    {...rest}
                />
            }
        </picture>
    )
}